import { axios } from '@/utils/request'

export function loadWebsiteList (parameter) {
  return axios({
    url: '/user/website/list',
    method: 'post',
    data: parameter
  })
}

export function recheckSite (parameter) {
  return axios({
    url: '/user/website/recheck',
    method: 'post',
    data: parameter
  })
}

export function saveWebsiteInfo (parameter) {
  return axios({
    url: '/user/website/info/save',
    method: 'post',
    data: parameter
  })
}

export function loadCertInfoList (parameter) {
  return axios({
    url: '/user/cert/list',
    method: 'post',
    data: parameter
  })
}

export function saveCertRequest (parameter) {
  return axios({
    url: '/user/cert/req/manual',
    method: 'post',
    data: parameter
  })
}

export function reIssuanceCert (parameter) {
  return axios({
    url: '/user/cert/redo',
    method: 'post',
    data: parameter
  })
}

export function deleteCertInfo (parameter) {
  return axios({
    url: '/user/cert/del',
    method: 'post',
    data: parameter
  })
}

export function loadPointRecordList (parameter) {
  return axios({
    url: '/user/point/record/list',
    method: 'post',
    data: parameter
  })
}

export function loadCloudDomainInfoList (parameter) {
  return axios({
    url: '/user/cloud/domain/list',
    method: 'post',
    data: parameter
  })
}

export function checkDomainDNS (parameter) {
  return axios({
    url: '/user/cloud/domain/dns/check',
    method: 'post',
    data: parameter
  })
}

export function saveCloudAPIAuthInfo (parameter) {
  return axios({
    url: '/user/cloud/auth/save',
    method: 'post',
    data: parameter
  })
}

export function loadCloudSettingInfoList (parameter) {
  return axios({
    url: '/user/cloud/setting/list',
    method: 'post',
    data: parameter
  })
}

export function loadMessageList (parameter) {
  return axios({
    url: '/user/massage/list',
    method: 'post',
    data: parameter
  })
}

export function loadNotificationList (parameter) {
  return axios({
    url: '/user/notify/list',
    method: 'post',
    data: parameter
  })
}

export function changeKey (parameter) {
  return axios({
    url: '/user/key/change',
    method: 'post',
    data: parameter
  })
}

export function generateWechatBindQr (parameter) {
  return axios({
    url: '/user/wechat/bind/qr',
    method: 'post',
    data: parameter
  })
}

export function generateWechatLoginQr (parameter) {
  return axios({
    url: '/user/login/client/qr',
    method: 'post',
    data: parameter
  })
}

export function saveUserFeedback (parameter) {
  return axios({
    url: '/user/feedback/save',
    method: 'post',
    data: parameter
  })
}

export function resetPassword (parameter) {
  return axios({
    url: '/user/password/reset',
    method: 'post',
    data: parameter
  })
}

export function savePushClientInfo (parameter) {
  return axios({
    url: '/user/event/push/client/info',
    method: 'post',
    data: parameter
  })
}

export function updatePushClientAlertSetting (parameter) {
  return axios({
    url: '/user/event/push/client/alert/setting',
    method: 'post',
    data: parameter
  })
}

export function loadPushClientInfoList (parameter) {
  return axios({
    url: '/user/event/push/client/list',
    method: 'post',
    data: parameter
  })
}

export function genPushClientBindQr (parameter) {
  return axios({
    url: '/user/event/push/client/qr',
    method: 'post',
    data: parameter
  })
}

export function deleteWebsite (parameter) {
  return axios({
    url: '/user/website/del',
    method: 'post',
    data: parameter
  })
}

export function batchDeleteWebSiteInfo (parameter) {
  return axios({
    url: '/user/website/batch/del',
    method: 'post',
    data: parameter
  })
}

export function downloadFormattedCertFile (parameter) {
  return axios({
    url: '/user/cert/formatted/download',
    method: 'post',
    timeout: 120000,
    data: parameter
  })
}

export function createWechatOrder (parameter) {
  return axios({
    url: '/user/wechat/order/create',
    method: 'post',
    data: parameter
  })
}

export function saveVisitorInfo (parameter) {
  return axios({
    url: '/user/visitor/bind',
    method: 'post',
    data: parameter
  })
}

export function deleteCloudSettingInfo (parameter) {
  return axios({
    url: '/user/cloud/auth/del',
    method: 'post',
    data: parameter
  })
}
